const addToCart = document.querySelector("#AddToCart");

addToCart.addEventListener("click", (e) => {
  e.preventDefault();
  const addToCartForm = document.querySelector('form[action$="/cart/add"]');
  const cartItemCounts = document.querySelectorAll(".cart-icon-bubble-link");
  const formData = new FormData(addToCartForm);

  const cartCountStr = `
                  <div class="cart-count-bubble">
                      <span aria-hidden="true"></span>
                  </div>`;

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      return fetch(window.Shopify.routes.root + "cart.js");
    })
    .then((response) => response.json())
    .then((data) => {
      const dummyDiv = document.createElement("div");
      dummyDiv.innerHTML = cartCountStr;
      const dummyDivChildElm = dummyDiv.querySelector("span");
      dummyDivChildElm.textContent = data.item_count;
      cartItemCounts.forEach((cartItemCount) => {
        const existingCountBubble =
          cartItemCount.querySelector(".cart-count-bubble");
        if (existingCountBubble) {
          existingCountBubble.remove();
        }
        cartItemCount.appendChild(dummyDiv.firstElementChild.cloneNode(true));
      });

      modalOpen();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});

let modalOpen = () => {
  $("#modalArea").fadeIn();
};

$("#closeModal1 , #modalBg , #closeModal2").click(function () {
  $("#modalArea").fadeOut();
});
